(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* StickyHeader custom element removed — header is non-sticky and no matching CSS existed. */

  /* ────────────────────────────────────────────────────────────────
     MENU DRAWER (custom, replaces Dawn's <details> + menu-drawer.js flow)
     Portals .menu-drawer to <body> on init so no ancestor (transform,
     filter, overflow:hidden) can clip it. Hijacks the hamburger summary
     click in CAPTURE phase to fully bypass Dawn's onSummaryClick.
     ──────────────────────────────────────────────────────────────── */
  (function () {
    if (window.__suMenuInit) return;
    window.__suMenuInit = true;

    function initMenu () {
      var details = document.getElementById('Details-menu-drawer-container');
      if (!details) return;
      var summary = details.querySelector(':scope > summary');
      var drawer = details.querySelector(':scope > .menu-drawer');
      if (!summary || !drawer) return;

      /* Portal the drawer to <body> — escapes all ancestor positioning quirks */
      if (!drawer.classList.contains('su-menu-drawer-portal')) {
        drawer.classList.add('su-menu-drawer-portal');
        document.body.appendChild(drawer);
        /* Override Dawn's height calc which would resolve to 0 once portaled
           (the `100%` fallback now means body-height, not header-height). */
        drawer.style.setProperty('--header-bottom-position', '0px');
        drawer.style.setProperty('--viewport-height', '100dvh');
      }

      /* Create overlay once */
      var overlay = document.querySelector('.su-menu-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'su-menu-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        document.body.appendChild(overlay);
      }

      function openMenu () {
        document.body.classList.add('su-menu-open');
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        var rdClose = drawer.querySelector('[data-rd-menu-close]');
        if (rdClose) { try { rdClose.focus({ preventScroll: true }); } catch (err) {} }
      }
      function closeMenu () {
        document.body.classList.remove('su-menu-open');
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }
      function toggleMenu () {
        if (document.body.classList.contains('su-menu-open')) closeMenu();
        else openMenu();
      }

      /* CAPTURE phase — runs BEFORE Dawn's menu-drawer.js bubble-phase handler.
         stopImmediatePropagation prevents Dawn's handler from firing at all. */
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleMenu();
      }, true);

      /* Tap overlay → close */
      overlay.addEventListener('click', closeMenu);

      /* 2026-09-23 redesign: the drawer carries its own close button */
      drawer.querySelectorAll('[data-rd-menu-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          closeMenu();
          try { summary.focus({ preventScroll: true }); } catch (err) {}
        });
      });

      /* Esc → close */
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.code === 'Escape') && document.body.classList.contains('su-menu-open')) closeMenu();
      });

      /* Tap a menu link → close (so when user navigates, drawer cleans up) */
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { closeMenu(); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenu);
    } else {
      initMenu();
    }
  })();

  /* ── SU Language Switcher — Shopify Markets URL-prefix nav ───────────
     Translation engine: Shopify Translate & Adapt (free, native).
     Routing: Shopify Markets handles /<lang>/path automatically when
     the merchant adds Arabic in Settings → Languages and enables it
     for the relevant market.
     This switcher simply navigates to the prefixed URL — Shopify does
     the rest (sets <html lang>, dir="rtl" for ar, serves translated
     content via the Liquid `t:` system or per-resource translations).
  */
  (function () {
    if (window.__suLangInit) return;
    window.__suLangInit = true;

    /* All langs Shopify Markets might use — extend if you add more in Admin. */
    var KNOWN_LANGS = ['ar', 'en', 'fr', 'es', 'de', 'tr', 'ru', 'hi', 'ur'];
    var LANG_RE = new RegExp('^/(' + KNOWN_LANGS.join('|') + ')(/|$)');

    function detectCurrentLang () {
      /* 1. URL prefix wins (Shopify Markets pattern) */
      var m = window.location.pathname.match(LANG_RE);
      if (m) return m[1];
      /* 2. <html lang> attr (Shopify auto-sets per locale) */
      var html = (document.documentElement.lang || '').toLowerCase().split('-')[0];
      if (html && KNOWN_LANGS.indexOf(html) > -1) return html;
      /* 3. Default to English */
      return 'en';
    }

    function navigateToLang (target) {
      /* Strip any existing lang prefix, then prepend the new one (unless EN/default). */
      var pathWithoutLang = window.location.pathname.replace(LANG_RE, '/');
      var newPath = (target === 'en') ? pathWithoutLang : '/' + target + pathWithoutLang;
      /* Preserve query + hash */
      window.location.assign(newPath + window.location.search + window.location.hash);
    }

    function initLang () {
      var wrap = document.getElementById('su-lang');
      if (!wrap) return;
      var face = document.getElementById('su-lang-face');
      var opts = wrap.querySelectorAll('.su-lang__opt');

      function setActive (lang) {
        if (!lang) return;
        wrap.setAttribute('data-lang', lang);
        if (face) face.textContent = (lang || 'en').toUpperCase();
        opts.forEach(function (o) {
          o.classList.toggle('is-active', o.getAttribute('data-lang') === lang);
        });
      }

      var current = detectCurrentLang();
      setActive(current);

      /* Pill expand/collapse */
      if (face) {
        face.addEventListener('click', function (e) {
          e.stopPropagation();
          wrap.classList.toggle('is-open');
        });
      }

      /* Option click → navigate */
      opts.forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          var lang = opt.getAttribute('data-lang');
          if (!lang || lang === current) {
            wrap.classList.remove('is-open');
            return;
          }
          setActive(lang); /* optimistic UI */
          wrap.classList.remove('is-open');
          /* Slight delay so the pill animation finishes before the navigation */
          setTimeout(function () { navigateToLang(lang); }, 80);
        });
      });

      /* Click outside closes the expanded pill */
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) wrap.classList.remove('is-open');
      });
    }

    /* 2026-09-23 redesign: the drawer pills and the footer pill ([data-su-lang-link]) use the same
       URL navigation (CLAUDE.md rule 12). Delegated, so the footer needs no script of its own. */
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('[data-su-lang-link]') : null;
      if (!link) return;
      var lang = link.getAttribute('data-su-lang-link');
      e.preventDefault();
      if (!lang || lang === detectCurrentLang()) return;
      navigateToLang(lang);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLang);
    } else {
      initLang();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
